import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Line,
  ReferenceArea,
  LabelProps,
  ReferenceAreaProps,
} from "recharts";

interface HospitalizationChartProps {
  data: App.HospitalRecord[] | App.HospitalCensusRecord[];
  name: string;
  startPre?: string;
}

export default function HospitalAdmission(props: HospitalizationChartProps) {
  const { data, name, startPre } = props;

  function referenceLabel(props: ReferenceAreaProps) {
    const { viewBox } = props;
    if (!viewBox || !viewBox.x || !viewBox.y) return;
    return (
      <text className="prelim-text" x={viewBox.x - 65} y={viewBox.y + 30}>
        prelim &rarr;
      </text>
    );
  }

  function customizedLabel(props: LabelProps) {
    const { x, y, value } = props;
    return (
      <text
        className="dataLabel"
        x={x}
        y={y}
        dy={-10}
        fontSize={10}
        textAnchor="middle"
      >
        {value}
      </text>
    );
  }

  return (
    <ResponsiveContainer height={400}>
      <LineChart
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis dataKey="date" />
        <YAxis domain={[0, (dataMax) => Math.round(dataMax * 1.05)]} />
        {startPre ? (
          <ReferenceArea
            x1={startPre}
            strokeOpacity={0.3}
            label={(props: ReferenceAreaProps) => referenceLabel(props)}
          />
        ) : null}
        <Tooltip />
        <Legend />
        <Line
          name={name}
          dot={false}
          strokeWidth="2"
          type="monotone"
          dataKey="value"
          stroke="#002e6c"
          label={(props: LabelProps) => customizedLabel(props)}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
